import { Injectable } from '@angular/core';
import { Observable, EMPTY, of } from 'rxjs';
import {
  IChatService,
  ChatContext,
  ChatMessage,
  ChatStreamEvent,
} from '@infinitform/platform-core';

@Injectable()
export class ChatCloudService implements IChatService {
  /**
   * Cloud builds always have agent access via WebSocket; the actual chat
   * transport lives in AssistantChatComponent (not this service). This
   * gate is consumed by EditorAuthFacadeService.hasAiChatFeature().
   */
  isAvailable(): boolean {
    return true;
  }

  sendMessage(_message: string, _context: ChatContext): Observable<ChatStreamEvent> {
    return EMPTY;
  }

  getHistory(_projectId: string): Observable<ChatMessage[]> {
    return of([]);
  }

  clearHistory(_projectId: string): Observable<void> {
    return of(undefined);
  }
}
